export const excel_user_col_def = [
    {
        label: "User ID",
        key: "id",
    },
    {
        label: "Phone Number",
        key: "phonenum",
    },
    {
        label: "Name",
        key: "name",
    },
    {
        label: "Role",
        key: "role",
    },
];

export const userRoles = [
    { label: "Root", value: "root" },
    { label: "Admin", value: "client" },
    { label: "Super Admin", value: "superadmin" },
    { label: "Party worker", value: "partyworker" },
    { label: "Back office", value: "backoffice" },
    { label: "Field Worker", value: "surveyworker" },
    { label: "QA Worker", value: "qaworker" },
];

export const map_roles_by_key = {
    "": "Select role",
    root: "Root",
    client: "Admin",
    superadmin: "SuperAdmin",
    partyworker: "Party worker",
    backoffice: "Back office",
    surveyworker: "Field Worker",
    qaworker: "QA Worker",
};

export const groupObjectsByKey = (users) => {
    if (users && users.length <= 0) return null;
    return users?.reduce(function (r, a) {
        r[a.role] = r[a.role] || [];
        r[a.role].push(a);
        return r;
    }, Object.create(null));
};
